const WITHDRAWN_ON_ARCHIVE = [
    'paymentConnected',
    'reviewed',
    'sent',
    'scheduled',
    'draft'
];
export const dropWithdrawnAgreements = (items)=>items === null || items === void 0 ? void 0 : items.filter((item)=>!WITHDRAWN_ON_ARCHIVE.includes(item.status));
